import {useLayoutEffect,useRef,type ReactNode} from 'react';
import {useWebViewport} from '@platform/ui/config';

// One responsive room structure: stacked on small screens; stage left and
// cards right on desktop; purchase popups keep a stacked stage/catalogue.
// Desktop checkout sticks above the list; mobile keeps its existing bottom dock.
export function RoomColumns({stage,children,footer,banner,stacked=false}:{stage:ReactNode;children:ReactNode;footer:ReactNode;banner?:ReactNode;stacked?:boolean}){
 const desktop=useWebViewport(),root=useRef<HTMLDivElement>(null);
 useLayoutEffect(()=>{
  const element=root.current;if(!desktop||!element)return;
  const dialog=element.closest<HTMLElement>('.next-round-purchase'),scope=dialog??document.documentElement;
  const actions=element.querySelector<HTMLElement>('.room-top-actions')!,stage=element.querySelector<HTMLElement>('.room-stage-content')!,broadcast=element.querySelector<HTMLElement>('.room-stage-broadcast');
  const measure=()=>{
   if(dialog)scope.style.setProperty('--room-viewport-height',dialog.clientHeight+'px');
   scope.style.setProperty('--room-top-actions-height',actions.getBoundingClientRect().height+'px');
   // Keep readable cells. When even three rows cannot fit, the existing video
   // board control opens the full table instead of shrinking the numbers.
   if(!stacked)stage.dataset.boardCompact=String(stage.clientHeight-(broadcast?.getBoundingClientRect().height??0)<144);
  };
  measure();const observer=new ResizeObserver(measure);
  [actions,stage,broadcast,dialog].forEach(item=>{if(item)observer.observe(item);});
  return()=>{observer.disconnect();scope.style.removeProperty('--room-top-actions-height');if(dialog)scope.style.removeProperty('--room-viewport-height');delete stage.dataset.boardCompact;};
 },[desktop,stacked]);
 return <div ref={root} className="room-main" data-stacked={stacked}><div className="room-stage-column"><div className="room-stage-content">{stage}</div></div><div className="room-play-column">{desktop&&<div className="room-top-actions">{banner}{footer}</div>}{children}</div>{!desktop&&footer}</div>;
}

export function StageBroadcast({children}:{children:ReactNode}){
 return <div className="room-stage-broadcast">{children}</div>;
}
